import { render, staticRenderFns } from "./personalConfig.vue?vue&type=template&id=cea8cdba&scoped=true&"
import script from "./personalConfig.vue?vue&type=script&lang=js&"
export * from "./personalConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea8cdba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/DiTuYouXuan/DiTuAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cea8cdba')) {
      api.createRecord('cea8cdba', component.options)
    } else {
      api.reload('cea8cdba', component.options)
    }
    module.hot.accept("./personalConfig.vue?vue&type=template&id=cea8cdba&scoped=true&", function () {
      api.rerender('cea8cdba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sysconfig/styleConfig/personalConfig.vue"
export default component.exports